import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {TextFieldModule} from '@angular/cdk/text-field';
import {MatInputModule} from '@angular/material/input';
import {MatToolbarModule} from '@angular/material/toolbar';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CommonModule, NgClass, NgOptimizedImage} from '@angular/common';
import {MatTabsModule} from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatMenuModule} from '@angular/material/menu';
import {LoadMaskComponent} from './load-mask/load-mask.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {UploadImageComponent} from './upload-image/upload-image.component';
import {MatCardModule} from '@angular/material/card';
import {MatListModule} from '@angular/material/list';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {SearchBarComponent} from './search-bar/search-bar.component';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {MatLineModule, MatNativeDateModule} from '@angular/material/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ImageCropperModule} from 'ngx-image-cropper';
import {UploadFormComponent} from './upload-form/upload-form.component';
import {SafeUrlPipe} from './pipes/safe-url.pipe';
import {ExternalHeaderComponent} from './external-header/external-header.component';
import {Building2, Calendar, CalendarX2, ChevronRight, Clock, Eye, Facebook, Instagram, Linkedin, Lock, LucideAngularModule, Mail, MapPin, Phone, User} from 'lucide-angular';
import {StickyMenuComponent} from './sticky-menu/sticky-menu.component';
import {IbanComponent} from './iban/iban.component';
import {RouterLink} from '@angular/router';
import {CustomTimeInputComponent} from './custom-time-input/custom-time-input.component';
import {PopupComponent} from './popup/popup.component';
import {FooterComponent} from './footer/footer.component';
import {ExternalHeaderMobileComponent} from './external-header-mobile/external-header-mobile.component';
import {BottomNavigationComponent} from './bottom-navigation/bottom-navigation.component';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {NotificationPanelComponent} from './notification-panel/notification-panel.component';
import {MobileNotificationComponent} from './app-mobile-notification/app-mobile-notification.component';
import {InputComponent} from './input/input.component';
import {DatePickerRangeComponent} from './date-picker-range/date-picker-range.component';
import {BannerComponent} from "./banner/banner.component";
import {CustomizedDropdownComponent} from './dropdown/customized-dropdown.component';
import {SelectOptionComponent} from "./select-option/select-option.component";
import {DropdownComponent} from "./countries-dropdown/dropdown.component";
import {DataService} from "./services/data.service";
import {ApplicationActionsComponent} from "./app-application-actions/app-application-actions.component";

@NgModule({
  exports: [
    LucideAngularModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    TextFieldModule,
    MatInputModule,
    MatToolbarModule,
    CommonModule,
    MobileNotificationComponent,
    LoadMaskComponent,
    SafeUrlPipe,
    UploadImageComponent,
    ExternalHeaderMobileComponent,
    NotificationPanelComponent,
    FooterComponent,
    SearchBarComponent,
    SelectOptionComponent,
    UploadFormComponent,
    ExternalHeaderComponent,
    InputComponent,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    TextFieldModule,
    MatInputModule,
    MatToolbarModule,
    CommonModule,
    LoadMaskComponent,
    SafeUrlPipe,
    UploadImageComponent,
    SearchBarComponent,
    BottomNavigationComponent,
    UploadFormComponent,
    ExternalHeaderComponent,
    InputComponent,
    CustomizedDropdownComponent,
    BannerComponent,
    StickyMenuComponent,
    DatePickerRangeComponent,
    IbanComponent,
    CustomTimeInputComponent,
    CustomTimeInputComponent,
    ApplicationActionsComponent,
    DropdownComponent,
  ],
  imports: [
    LucideAngularModule.pick({
      Facebook,
      Instagram,
      Linkedin,
      Mail,
      MapPin,
      Phone,
      Calendar,
      CalendarX2,
      Clock,
      ChevronRight,
      Building2,
      User,
    }),
    CommonModule,
    CommonModule,
    MatDialogModule,
    ApplicationActionsComponent,
    NgxMaterialTimepickerModule,
    ImageCropperModule,
    MatButtonModule,
    MatFormFieldModule,
    TextFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatIconModule,
    MatDatepickerModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatListModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    NgxMaterialTimepickerModule,
    MatNativeDateModule,
    NgOptimizedImage,
    MatLineModule,
    NgClass,
    LucideAngularModule.pick({Lock, Mail, Eye}),
    MatDialogModule,
    NgxMaterialTimepickerModule,
    ImageCropperModule,
    MatButtonModule,
    MatFormFieldModule,
    TextFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatIconModule,
    MatDatepickerModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatListModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    NgxMaterialTimepickerModule,
    MatNativeDateModule,
    NgOptimizedImage,
    MatLineModule,
    MatTooltipModule,
    RouterLink,
    ConfirmationDialogComponent,
    LoadMaskComponent,
    UploadImageComponent,
    FooterComponent,
    LoadMaskComponent,
    UploadImageComponent,
    CustomTimeInputComponent,
    PopupComponent,
    SearchBarComponent,
    SafeUrlPipe,
    UploadFormComponent,
    InputComponent,
    ExternalHeaderComponent,
    DatePickerRangeComponent,
    ExternalHeaderMobileComponent,
    SearchBarComponent,
    BannerComponent,
    SafeUrlPipe,
    UploadFormComponent,
    StickyMenuComponent,
    CustomizedDropdownComponent,
    MobileNotificationComponent,
    InputComponent,
    ExternalHeaderComponent,
    SelectOptionComponent,
    BottomNavigationComponent,
    DropdownComponent,
    NotificationPanelComponent,
    IbanComponent,
  ],
  providers: [TranslateService, DataService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class SharedModule {
}
